import { BillingState } from 'pages/Billing/types';
import { billingActionTypes } from 'store/billing/actionTypes';
import { ICustomMap } from 'types/ICustomMap';

export const setBillingAccountInfo = (payload: BillingState | ICustomMap) => ({
    type: billingActionTypes.SET_BILLING_ACCOUNT_INFO,
    payload,
});
